"use client";
import {
  createItemFile,
  deleteItem,
  fetchData,
  fetchDataNoPag,
  getOneItem,
  updateItemFile,
  updateItemJson,
} from "../../../../Api/hotelEndpoint";
import { createAsyncThunk } from "@reduxjs/toolkit";

/***------------- Get All Hotel Facility Data ------------- ***/
export const fetchFacility = createAsyncThunk(
  "hotel/facility/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const { data, totalPages, totalItems } = await fetchData({
        endpoint: "hotel/facility/fetchAll",
        ...params,
      });
      return { data, totalPages, totalItems };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- update Facility Order - API ------------- ***/
export const updateFacilityOrder = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: "hotel/update-facility-order",
      formData,
    });

    if (data) return formData;
    else throw new Error("Request failed");
  } catch (error) {
    throw error;
  }
};

/***------------- Get One Facility Room Data ------------- ***/
export const fetchOneFacility = createAsyncThunk(
  "hotel/facility/fetch",
  async ({ id }, { rejectWithValue }) => {
    try {
      const data = await getOneItem(`hotel/facility/fetch/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Get All Hotel Facility ------------- ***/
export const fetchAllHotelFacility = async () => {
  try {
    const data = await fetchDataNoPag({
      endpoint: "fetchAllHotelFacilities",
    });
    return data && data;
  } catch (error) {
    throw error;
  }
};

/***------------- Add Hotel Facility - API ------------- ***/
export const createHotelFacility = createAsyncThunk(
  "hotel/facility/create",
  async ({ formData, router }, { rejectWithValue }) => {
    try {
      const data = await createItemFile({
        endpoint: "hotel/facility/create",
        formData,
      });
      if (data) {
        router.push("/hotel/facilities");
        return data;
      } else throw new Error("Request failed");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- update Hotel Facility - API ------------- ***/
export const updateHotelFacility = createAsyncThunk(
  "hotel/facility/update",
  async ({ formData, router }, { rejectWithValue }) => {
    try {
      const data = await updateItemFile({
        endpoint: "hotel/facility/update",
        formData,
        id: formData._id,
      });
      if (data) {
        router.push("/hotel/facilities");
        return { id: formData._id, data };
      } else {
        throw new Error("Request failed");
      }
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- Delete Hotel Facility - API ------------- ***/
export const deleteHotelFacility = createAsyncThunk(
  "hotel/facility/delete",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/facility",
        ...deleteData,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Delete-undo Hotel Facility - API ------------- ***/
export const deleteUndoHotelFacility = createAsyncThunk(
  "hotel/facility/delete-undo",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/facility",
        ...deleteData,
        undo: true,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
